export default __webpack_public_path__ + "static/media/UNDER_ANALYSIS_BY_THE_EXPERT.f3630bdf.svg";